"use strict";

jQuery(document).ready(function($) {
  // Custom country switcher
  $('.country-dorpdown').click(function(event){
    $(this).toggleClass('active');
    event.preventDefault();
  });
  $('.country-dorpdown .canada_en').click(function(event){
    event.stopPropagation();
  });

  
});

